export default __webpack_public_path__ + "static/media/expand.8151b4b0.svg";